<template>
    <div class="house-tile keep-polygon-active" @mouseover="highlight" @mouseout="removeHighlight">
        <div class="house-tile__header d-flex justify-content-between">
            <div class="house-tile__header--title d-flex flex-column handle">
                <h3>{{ objectTitle }}</h3>
                <h5 v-if="house.status === 'Onder optie'" class="consultation">{{ house.status }}</h5>
                <h5 v-if="house.status === 'Onder bod'" class="consultation">{{ house.status }}</h5>
                <h5 v-if="house.status === 'Beschikbaar'" class="available">{{ house.status }}</h5>
                <h5 v-if="house.status === 'Verhuurd onder voorbehoud'" class="rented">{{ house.status }}</h5>
                <h5 v-if="house.status === 'Verhuurd per maand'" class="rented">{{ house.status }}</h5>
            </div>
            <div class="house-tile__header--cta">
                <router-link :to="{ name: 'detail', params: { object_id: house.id} }" class="btn btn-grey show-house keep-polygon-active">Bekijk woning</router-link>

                <!--<button class="btn btn-grey btn-like btn-like__liked icon-heart-filled" v-if="isliked" @click="dislike"></button>-->

                <button  @click="like" :class="{ liked: liked }" v-if="house.status === 'Beschikbaar'" class="btn btn-grey btn-like icon-heart keep-polygon-active"></button>

                <div class="house-tooltip">Woning toegevoegd aan je <a @click="toPreferences">favorieten</a></div>

            </div>
        </div>
        <div class="house-tile__body handle">
            <div class="row">
                <div class="col-3">
                    <div class="house-attribute">
                        <span>Huurprijs</span>
                        <h4>€ {{ house.price_value }} /mnd</h4>
                    </div>
                </div>
                <div class="col-3">
                    <div class="house-attribute">
                        <span>Slaapkamers</span>
                        <h4>{{ house.characteristics.sleeping_rooms }} slaapkamer<span v-if="house.characteristics.sleeping_rooms !== 1">s</span></h4>
                    </div>
                </div>
                <div class="col-3">
                    <div class="house-attribute">
                        <span>Oppervlakte</span>
                        <h4>{{ house.characteristics.surface }}m²</h4>
                    </div>
                </div>
                <div v-if="house.service_costs" class="col-3">
                    <div class="house-attribute">
                        <span>Servicekosten</span>
                        <h4>€ {{ Math.round(house.service_costs) }},-</h4>
                    </div>
                </div>
            </div>
        </div>

        <div class="house-tile__overlay keep-polygon-active">
            <button @click="hideOverlay" class="btn btn-primary btn-white-40 keep-polygon-active">Behouden</button>
            <button @click="dislike" class="btn btn-red keep-polygon-active">Verwijderen</button>
        </div>

    </div>
</template>

<script>
    export default {

        props:{
            house: Object,
            houseindex: Number
        },
        data() {
            return {
                parent:  this.$parent,
            }
        },

        created(){
            // Create the "new" houseindex value
            this.house.houseindex = this.houseindex
        },
        mounted() {

//            console.log(this.house)

        },
        computed: {
            liked () {
                return this.$store.state.favorites.includes(this.house.id)
            },
          objectTitle () {
              if(this.$store.state.apiData.building_title){
                let type = this.$store.state.apiData.building_title
                if(type === 'address'){
                  return this.house.address.street + ' ' + this.house.address.number + this.house.address.number_suffix
                }
              }
              return 'Bouwnummer ' + this.house.build_number
          }
        },
        methods: {
            toPreferences() {
                this.showPopup = false
                document.body.classList.remove('drop-down-open-pref')
                this.$router.push({ name: 'preferences' })
            },
            highlight(){
                if(this.$store.state.highlighted !== this.house.id){
                    this.$store.commit('highlight', this.house.id)
                }
            },
            removeHighlight(){
                if(this.$store.state.highlighted === this.house.id){
                    this.$store.commit('highlight', null)
                }
            },
            like () {
                if(!this.liked){
                  let maxPreferences = this.$store.state.apiData.max_preferences
                  if(maxPreferences && this.$store.state.favorites.length >= maxPreferences){
                    this.$store.commit('favoriteLimitReached', true)
                    return
                  }
                    this.$store.commit('addFavorite', this.house.id)

                    const tooltip = this.$el.querySelector('.house-tooltip')
                    tooltip.classList.add('active')

                    setTimeout(function(){
                        tooltip.classList.remove('active')
                    }, 2000);

                } else {
                    this.$el.querySelector('.house-tile__overlay').classList.add('active')
                }
            },
            dislike(){
                this.$store.commit('removeFavorite', this.house.id)
                this.$el.querySelector('.house-tile__overlay').classList.remove('active')
            },
            hideOverlay() {
                this.$el.querySelector('.house-tile__overlay').classList.remove('active')
            }

        },

    }
</script>
